<template>
    <div class="d-flex justify-center parent" style="width:250px; height:30px">
        <svg xmlns="http://www.w3.org/2000/svg" :width=250 :height=18 viewBox="0 0 250 18" fill="none">
            <path d="M 0 16 H 30 C 63 16 108 -12 109 16 C 133 4 182 -11 180 16 H 250" stroke="black" stroke-width="2" />
        </svg>
        <Vue3DraggableResizable v-model:x="this.x" :draggable="true" :resizable="false" :disabledY="true" :parent="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle style="cursor:pointer;" cx="15" cy="12" r="10" fill="yellow" fill-opacity="0.8" stroke="black" />
            </svg>
        </Vue3DraggableResizable>
    </div>
</template> 
  
<script>
import Vue3DraggableResizable from 'vue3-draggable-resizable'
//default styles
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

export default {
    props: ['volumeLevel'],
    components: {
        Vue3DraggableResizable
    },
    inject: ["eventBus"],
    data() {
        return {
            x: this.volumeLevel,
            active: true,
            hover: true
        }
    },
    watch: {
        x(newVal) {
            this.eventBus.emit('volume-value', newVal)
        }
    },
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vdr-container.active {
    border-color: transparent;
}

.vdr-container.dragging {
    border-color: transparent;
}

.parent {
    position: relative;
    border-bottom: 2px solid black;
}
</style>
  